import { render, staticRenderFns } from "./printDailySummary_TB.vue?vue&type=template&id=2f4e0ff4&scoped=true&"
import script from "./printDailySummary_TB.vue?vue&type=script&lang=js&"
export * from "./printDailySummary_TB.vue?vue&type=script&lang=js&"
import style0 from "./printDailySummary_TB.vue?vue&type=style&index=0&id=2f4e0ff4&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e0ff4",
  null
  
)

component.options.__file = "printDailySummary_TB.vue"
export default component.exports